import { useAtom } from "jotai";
import { Text } from "@zapier/design-system";
import {
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
} from "@zapier/design-system-beta";
import {
  nodeViewModeAtom,
  nodeMetricsToDisplayAtom,
  NodeViewMode,
  NodeMetric,
  sessionAtom,
} from "@zapier/canvas-state";
import styles from "./DisplayPreferencesPanel.module.css";

export function DisplayPreferencesPanel() {
  const [nodeViewMode, setNodeViewMode] = useAtom(nodeViewModeAtom);
  const [nodeMetricsToDisplay, setNodeMetricsToDisplay] = useAtom(
    nodeMetricsToDisplayAtom,
  );
  const [session] = useAtom(sessionAtom);

  return (
    <div className={styles.wrapper}>
      <Text type="Body1" tag="p" className={styles.temporaryNote}>
        {session?.is_logged_in
          ? "These settings are temporary and will reset when you reload the page"
          : "Log in to customize your view settings"}
      </Text>

      <fieldset className={styles.section}>
        <legend className={styles.legend}>
          <Text type="Body4" tag="p">
            View Mode for Zapier Assets
          </Text>
          <Text type="Body1" tag="p" className={styles.legendDescription}>
            Change the view for Interfaces and Tables steps:
          </Text>
        </legend>
        <RadioGroup
          aria-label="View mode selection for Zapier assets"
          value={nodeViewMode}
          onChange={(value) => setNodeViewMode(value as NodeViewMode)}
          className={styles.radioGroup}
          isDisabled={!session?.is_logged_in}
        >
          <Radio value="collapsed">
            <Text type="Body4">Collapsed&nbsp;</Text>
            <Text type="Body1">— Simplified view</Text>
          </Radio>
          <Radio value="expanded">
            <Text type="Body4">Expanded&nbsp;</Text>
            <Text type="Body1">— Detailed view</Text>
          </Radio>
        </RadioGroup>
      </fieldset>

      <fieldset className={styles.section}>
        <legend>
          <Text type="Body4" tag="p">
            Step Metrics
          </Text>
          <Text type="Body1" tag="p" className={styles.legendDescription}>
            Choose which metrics to display on steps:
          </Text>
        </legend>
        <CheckboxGroup
          aria-label="Step metrics display preferences"
          isDisabled={!session?.is_logged_in}
          onChange={(values) => setNodeMetricsToDisplay(values as NodeMetric[])}
          value={nodeMetricsToDisplay}
        >
          <Checkbox value="zapRuns">Zap runs</Checkbox>
          <Checkbox value="formSubmissionCount">
            Zapier Interfaces form submission count
          </Checkbox>
          <Checkbox value="tableRecordUsage">
            Zapier Tables record usage
          </Checkbox>
          <Checkbox value="timeSpentOrSaved">Time spent / saved</Checkbox>
        </CheckboxGroup>
      </fieldset>
    </div>
  );
}
